import axios from "axios";

// import { bun_server } from "./baseUrl";

import generate_uuid from "../validation/generate_uuid";

// Function to detect browser name
const get_browser_name = () => {
  const user_agent = navigator.userAgent;

  if (user_agent.includes("Firefox")) {
    return "Firefox";
  } else if (user_agent.includes("SamsungBrowser")) {
    return "Samsung";
  } else if (user_agent.includes("Opera") || user_agent.includes("OPR")) {
    return "Opera";
  } else if (user_agent.includes("Edge")) {
    return "Edge";
  } else if (user_agent.includes("Chrome")) {
    return "Chrome";
  } else if (user_agent.includes("Safari")) {
    return "Safari";
  } else {
    return "Unknown";
  }
};

// Function to detect OS name and version
const get_os_info = () => {
  const user_agent = navigator.userAgent;

  let os_name = "Unknown";
  let os_version = "";

  if (user_agent.includes("Windows NT")) {
    os_name = "Windows";
    const match = user_agent.match(/Windows NT ([\d.]+)/);
    if (match) {
      const version = match[1];
      switch (version) {
        case "10.0":
          os_version = "10";
          break;
        case "6.3":
          os_version = "8.1";
          break;
        case "6.2":
          os_version = "8";
          break;
        case "6.1":
          os_version = "7";
          break;
        case "6.0":
          os_version = "Vista";
          break;
        default:
          os_version = version;
      }
    }
  } else if (user_agent.includes("Mac OS X")) {
    os_name = "macOS";
    const match = user_agent.match(/Mac OS X ([\d_]+)/);
    if (match) {
      os_version = match[1].replace(/_/g, ".");
    }
  } else if (user_agent.includes("Android")) {
    os_name = "Android";
    const match = user_agent.match(/Android ([\d.]+)/);
    if (match) {
      os_version = match[1];
    }
  } else if (user_agent.includes("iPhone") || user_agent.includes("iPad")) {
    os_name = "iOS";
    const match = user_agent.match(/OS ([\d_]+)/);
    if (match) {
      os_version = match[1].replace(/_/g, ".");
    }
  } else if (user_agent.includes("Linux")) {
    os_name = "Linux";
  } else if (user_agent.includes("CrOS")) {
    os_name = "ChromeOS";
  }

  return { os_name, os_version };
};

// Updated activities_timeseries function
export const activities_timeseries = (action) => async (dispatch, getState) => {
  try {
    let id_visitor_local = localStorage.id_visitor;

    if (!id_visitor_local) {
      const state = getState();
      const { user } = state.auth;
      const user_id = user?._id || "guest";
      const browser_name = get_browser_name();
      const { os_name, os_version } = get_os_info();
      const uuid = generate_uuid();
      id_visitor_local = `${browser_name}_${os_name}_${os_version}_${uuid}_${user_id}`;
      localStorage.setItem("id_visitor", id_visitor_local);
    }

    dispatch({
      type: "set_loading_action",
      payload: "activities_timeseries",
    });

    const config = {
      headers: {
        accesstoken: localStorage?.token_mapid,
      },
    };

    const body = {
      id_visitor: id_visitor_local,
      page: window.location.pathname,
      domain: window.location.hostname,
      action: action,
    };

    const bun_server = "https://devserver.mapid.io";
    await axios.post(bun_server + "/activities_timeseries", body, config);

    dispatch({
      type: "clear_loading_action",
      payload: "activities_timeseries",
    });
  } catch (error) {
    console.error("Error in activities_timeseries:", error);
    dispatch({
      type: "clear_loading_action",
      payload: "activities_timeseries",
    });
  }
};
